const Theme = Object.freeze({
    LIGHT: 'Light',
    DARK: 'Dark',
    SYSTEM: 'System'
});

const THEME_LABELS_PT = Object.freeze({
    [Theme.LIGHT]: 'claro',
    [Theme.DARK]: 'escuro',
    [Theme.SYSTEM]: 'sistema'
});

const SUPPORTED_BACKGROUND_IMAGE_THEMES = Object.freeze([
    Theme.LIGHT,
    Theme.DARK
]);

function getThemeLabelPt(theme) {
    return THEME_LABELS_PT[theme] || theme;
}

export { Theme, SUPPORTED_BACKGROUND_IMAGE_THEMES, THEME_LABELS_PT, getThemeLabelPt };
